import { React, useState, useEffect,useRef } from "react";
import styled from "styled-components";
import { Layout, Table, Button, PageHeader } from "antd";
import {
  RightLayoutContainer,
  OtherPages,
  PageTitleComp,
} from "../styledElements";
import logoCompany from "../../Assets/Images/logo.svg";
import Iconmoon from "../../Components/IconsFiles/icon";
import * as htmlToImage from "html-to-image";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { useNavigate, useLocation } from "react-router";
import moment from "moment";
import { getExportParentReelDetails } from "../../Services/productionPlanningServices";
import { useReactToPrint } from 'react-to-print';
import { lengthUnit, weightUnit } from "../../Utils/Constant/MeasurementUnitList";
import { toHandlePOName } from "../../Utils/helper/helper";
const capitalize = (item) => item?.charAt(0)?.toUpperCase() + item?.slice(1);

const PrintData = styled.div`
  padding: 0px;
  margin: 40px auto;
  background-color: #fff;
  width: 845px;
`;

const ExportHeader = styled.div`
  background-color: #faf9f8;
  padding: 10px 15px;
  .file-header {
    display: flex;
    justify-content: space-between;
  }
  .file-header-logo {
    width: 130px;
    display: flex;
    img {
      width: 100%;
      align-self: center;
    }
  }
  .client-name {
    width: 25%;
  }
  .client-name h4 {
    font-size: 12px;
    font-family: var(--sf-pro-display-m);
    margin: 0px;
  }
  .client-name h6 {
    font-style: italic;
    color: #605e5c;
    font-size: 10px;
    margin: 0px;
  }
  .client-data {
    display: flex;
    > div {
      width: 50%;
      label {
        color: #000;
        font-size: 9px;
        font-family: var(--sf-pro-display-m);
        display: block;
      }
      span {
        color: #605e5c;
        font-size: 9px;
        font-family: var(--sf-pro-display-m);
        display: block;
      }
    }
  }
`;

const ExportTable = styled.div`
  table {
    width: 100%;
  }
  thead th {
    border-top: 1px solid #000;
    border-bottom: 1px solid #000;
  }
  td {
    border-bottom: 1px solid #000;
  }

  th,
  td {
    text-align: left;
    padding: 5px 5px;
  }
  th {
    text-transform: uppercase;
    font-size: 10px;
    line-height: 1.2;
    font-weight: 700;
    font-family: var(--sf-pro-text);
  }
  p {
    margin: 0;
    font-family: var(--sf-pro-text);
  }
  .order-d {
    p {
      text-transform: uppercase;
      font-size: 7px;
      font-weight: 600;
    }
    .order-d-l {
      p {
        text-transform: none;
        color: #605e5c;
        font-size: 7px;
        font-weight: 400;
      }
    }
  }
  .date {
    color: #000;
    font-size: 8px;
    font-weight: 600;
  }
  .p-detail {
    font-size: 7px;
    font-weight: 600;
    color: #605e5c;
  }
  .factor {
    color: #000;
    font-size: 7px;
    font-weight: 600;
    font-style: italic;
  }
  .p-ton {
    font-size: 8px;
    font-weight: 600;
    color: #000;
  }
  .reel {
    font-size: 8px;
    color: #605e5c;
    font-style: italic;
  }
  .remark {
    font-size: 8px;
    color: #000000;
    font-weight: 500;
    max-width: 110px;
    line-height: 1.2;
  }
  .address {
    font-size: 8px;
    color: #000000;
    font-weight: 500;
    max-width: 170px;
    line-height: 1.2;
  }
  .ms-2 {
    width: 50px;
  }
  .f-10 {
    font-size: 10px !important;
  }
`;

const ExportAdditional = styled.div`
  background-color: #e0e2e8;
  padding: 25px 15px 20px;
  margin: 20px 0;
  .export-additional {
    display: flex;
    flex-wrap: wrap;
    .additional-col {
      flex: 0 0 33.3%;
      max-width: 33.3%;
    }
  }
  .additional-col {
    label,
    p {
      font-family: var(--sf-pro-display-m);
      color: #3b3a39;
      line-height: 15px;
      margin-bottom: 6px;
      font-size: 12px;
    }
    label {
      font-size: 14px;
    }
  }
`;

function addScript(url) {
  const script = document.createElement("script");
  script.type = "application/javascript";
  script.src = url;
  document.head.appendChild(script);
}

addScript(
  "https://raw.githack.com/eKoopmans/html2pdf/master/dist/html2pdf.bundle.js"
);

const PrintParentReelPdf = (props) => {
  const [parentReelDetails, setParentReelDetails] = useState();
  const [product, setProduct] = useState();
  const [showLoader, setLoader] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const timeElapsed = Date.now();
  const today = new Date(timeElapsed);
  const [jobId, setJobId] = useState(location.state.jobId);
  const [parentReel, setParentReel] = useState(location.state.parentReel);
  const printRef = useRef();

  const exportHandler = () => {
    const input = document.getElementById("export-content");
    html2canvas(input, { useCORS: true, allowTaint: true, scrollY: 0 }).then(
      (canvas) => {
        const image = { type: "jpeg", quality: 0.98 };
        const margin = [0.5, 0.5];
        const filename = "myfile.pdf";

        var imgWidth = 8.5;
        var pageHeight = 11;

        var innerPageWidth = imgWidth - margin[0] * 2;
        var innerPageHeight = pageHeight - margin[1] * 2;

        // Calculate the number of pages.
        var pxFullHeight = canvas.height;
        var pxPageHeight = Math.floor(canvas.width * (pageHeight / imgWidth));
        var nPages = Math.ceil(pxFullHeight / pxPageHeight);

        // Define pageHeight separately so it can be trimmed on the final page.
        var pageHeight = innerPageHeight;

        // Create a one-page canvas to split up the full image.
        var pageCanvas = document.createElement("canvas");
        var pageCtx = pageCanvas.getContext("2d");
        pageCanvas.width = canvas.width;
        pageCanvas.height = pxPageHeight;

        // Initialize the PDF.
        var pdf = new jsPDF("p", "in", [8.5, 11]);

        for (var page = 0; page < nPages; page++) {
          // Trim the final page to reduce file size.
          if (page === nPages - 1 && pxFullHeight % pxPageHeight !== 0) {
            pageCanvas.height = pxFullHeight % pxPageHeight;
            pageHeight =
              (pageCanvas.height * innerPageWidth) / pageCanvas.width;
          }

          // Display the page.
          var w = pageCanvas.width;
          var h = pageCanvas.height;
          pageCtx.fillStyle = "white";
          pageCtx.fillRect(0, 0, w, h);
          pageCtx.drawImage(canvas, 0, page * pxPageHeight, w, h, 0, 0, w, h);

          // Add the page to the PDF.
          if (page > 0) pdf.addPage();
          debugger;
          var imgData = pageCanvas.toDataURL(
            "image/" + image.type,
            image.quality
          );
          pdf.addImage(
            imgData,
            image.type,
            margin[1],
            margin[0],
            innerPageWidth,
            pageHeight
          );
        }

        pdf.save("parent-reel.pdf");
      }
    );
  };

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });

  useEffect(() => {
    if (parentReel)
      getExportParentReelDetails({
        jobcard: jobId,
        parent_reel: parentReel,
      })
        .then((response) => {
          // console.log(response.data.data);
          if(response?.data?.data?.cutter_type === "duplex"){
            let leftPartitionData = "( ";
            let rightPartitionData = "( ";

            response.data.data.d_com.combinations.forEach((order, index) => {
              if(order.position === "left")
              leftPartitionData = leftPartitionData + order.width + " + ";
              else
              rightPartitionData = rightPartitionData + order.width + " + ";
            });

            let leftData = response.data.data.d_com.combinations.filter((order) => order.position === 'left');
            let rightData = response.data.data.d_com.combinations.filter((order) => order.position === 'right');

            if(leftData.length && rightData.length){
              leftPartitionData = leftPartitionData.substring(0, leftPartitionData.length-2);
              leftPartitionData = leftPartitionData + ") + ";
              rightPartitionData = rightPartitionData.substring(0, rightPartitionData.length-2);
              rightPartitionData = rightPartitionData + ")";
            }

            if(!leftData.length){
              leftPartitionData = '';
              rightPartitionData = rightPartitionData.substring(0, rightPartitionData.length-2);
              rightPartitionData = rightPartitionData + ")";
            }
  
            if(!rightData.length){
              rightPartitionData = '';
              leftPartitionData = leftPartitionData.substring(0, leftPartitionData.length-2);
              leftPartitionData = leftPartitionData + ")";
            }

            let partitionData = leftPartitionData + rightPartitionData;
            response.data.data["duplexCombinationArr"] = partitionData
          }
          setParentReelDetails(response.data.data);
        })
        .catch((error) => console.log(error));
    return () => {
      setParentReelDetails();
    };
  }, [parentReel]);

  return parentReelDetails ? (
    <RightLayoutContainer>
      <PageTitleComp className="marginRightAdg">
        <PageHeader
          ghost={false}
          onBack={() => window.history.back()}
          title={location?.state?.machine_type !== "cutter" ? "Parent Reel Preview" : "Parent Set Preview"}
          extra={[
            <Button
              key="1"
              className="themeBtn"
              onClick={handlePrint}
            >
              <Iconmoon icon="printer" size={16} color="#FFFFFF" />
              {location?.state?.machine_type !== "cutter" ? "Print Parent Reel" : "Print Parent Set"}
            </Button>,
          ]}
        ></PageHeader>
      </PageTitleComp>
      <PrintData id="export-content">
        <OtherPages>
          <Layout
            style={{
              backgroundColor: "#ffffff",
            }}
          >
            <div ref={printRef}>
              <ExportHeader>
                <div className="file-header">
                  <div className="file-header-logo">
                    <img src={logoCompany} alt="Kaiznn" />
                  </div>
                  <div className="client-name">
                  {location?.state?.machine_type !== "cutter" ? (<h4>Parent Reel: {parentReel}</h4>) : (
                    <h4>Parent Set: {parentReel}</h4>
                  )}
                    <div className="client-data">
                      <div>
                        <label>Number of records</label>
                        <span>{parentReelDetails.orders.length}</span>
                      </div>
                      <div>
                        <label>Date:</label>
                        <span>{moment(today).format("DD MMMM, YYYY")}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </ExportHeader>
              <ExportAdditional>
                <div className="export-additional">
                  <div className="additional-col">
                    <label>
                      D.COM:{" "}
                      {parentReelDetails.cutter_type === "duplex" ? (
                        `${parentReelDetails.duplexCombinationArr}`
                        ) : (
                          parentReelDetails.d_com.combinations.map(
                            (item, index, array) =>
                              `${item.width} ${
                                index + 1 !== array.length ? "+" : ""
                              }`
                          )
                      )}{" "}
                      = {parentReelDetails.d_com.total}{" "}{parentReelDetails?.units && parentReelDetails?.units?.total ? lengthUnit[parentReelDetails.units.total]?.displayName?.toUpperCase() : "CM"}
                    </label>
                    <p>Left Trim: {parentReelDetails.left_edge_trim} {" "} {parentReelDetails?.units && parentReelDetails?.units?.left_edge_trim ? lengthUnit[parentReelDetails.units.left_edge_trim]?.displayName?.toUpperCase() : "CM"} </p>
                    <p>Right Trim: {parentReelDetails.right_edge_trim} {" "} {parentReelDetails?.units && parentReelDetails?.units?.right_edge_trim ? lengthUnit[parentReelDetails.units.right_edge_trim]?.displayName?.toUpperCase() : "CM"}</p>
                    <p>Deckle Width: {parentReelDetails.deckle_width} {" "} {parentReelDetails?.units && parentReelDetails?.units?.deckle_width ? lengthUnit[parentReelDetails.units.deckle_width]?.displayName?.toUpperCase() : "CM"}</p>
                  </div>
                  <div className="additional-col">
                    <label>GSM: {parentReelDetails.gsm} </label>
                    <p>Burst Factor: {parentReelDetails.burst_factor}</p>
                    <p>Grade: {parentReelDetails.grade}</p>
                    <p>Quality: {parentReelDetails.quality} </p>
                    {location?.state?.machine_type !== "cutter" ? (<p>
                      ID / OD: {parentReelDetails.core_id} /{" "}
                      {parentReelDetails.reel_od} {" "} {parentReelDetails?.units && parentReelDetails?.units?.reel_od ? lengthUnit[parentReelDetails.units.reel_od]?.displayName?.toUpperCase() : "CM"}
                    </p>):(null) }
                  </div>
                  <div className="additional-col">
                  {location?.state?.machine_type !== "cutter" ? (<label>Parent Reel No.: {parentReel}</label>):
                  (<label>Parent Set No.: {parentReel}</label>)}
                    <p>
                      Jumbo Reels:{" "}
                      {parentReelDetails.jumbo_reels.map(
                        (item, index, array) =>
                          `${item.number} (${item.weight} ${" "} ${item.units && item.units.weight ? capitalize(weightUnit[item.units.weight]?.displayName) : "T"})${
                            index + 1 !== array.length ? ", " : ""
                          }`
                      )}
                    </p>
                    {parentReelDetails.rewinding_date && location?.state?.machine_type !== "cutter" && <p>
                      Rewinding Date:{" "}
                      {moment(parentReelDetails.rewinding_date).format(
                        "DD-MM-YYYY"
                      )}
                    </p>}
                    {!parentReelDetails.rewinding_date && location?.state?.machine_type !== "cutter" && <p>
                          Rewinding Date:</p>}
                    
                      {parentReelDetails.cutting_date && location?.state?.machine_type === "cutter" && <p>
                      Cutting Date:{" "}{moment(parentReelDetails.cutting_date).format("DD-MM-YYYY")}
                    </p>}

                    {!parentReelDetails.cutting_date && location?.state?.machine_type === "cutter" && <p>
                          Cutting Date:</p>}

                    {location?.state?.machine_type === "rewinder" ? (
                    <p>Rewinding Shift: {parentReelDetails.rewinding_shift}</p>) : (
                      <p>Cutting Shift: {parentReelDetails.cutting_shift}</p>
                    )}
                  </div>
                </div>
              </ExportAdditional>
              <ExportTable>
                <table>
                  <thead>
                    <tr>
                      <th>ORDER DETAILS</th>
                      {location?.state?.machine_type !== "cutter" ? (<th>REEL NUMBER</th>) : (<th>SHEET NUMBER</th>)}
                      {location?.state?.machine_type !== "cutter" ? (<th>REEL WEIGHT</th>) : (<th>SHEET WEIGHT</th>)}
                      <th>ORDER DIMENSION</th>
                      <th>CUSTOMER DETAILS</th>
                      <th>PRIORITY</th>
                      <th>REMARKS</th>
                    </tr>
                  </thead>
                  <tbody>
                    {parentReelDetails.orders.map((reel) => (
                      <tr>
                        {reel.item_type === "order" ? (
                          <td>
                           <p className="p-ton f-10">PO/SO NO.: {toHandlePOName(reel.po||reel.so)}</p>
                            <p className="p-ton f-10">ORDER NO.: {reel.order}</p>
                          </td>
                        ) : (
                          <td>
                            <p className="p-ton f-10">STOCK NO.: {reel.stock}</p>
                          </td>
                        )}
                        <td>
                          <p className="p-detail f-10">{reel.reel}</p>
                        </td>
                        <td>
                          <p className="p-ton f-10">{reel.reel_weight? reel.reel_weight?.toFixed(3) : 0} {" "} {reel.units && reel.units.reel_weight ? capitalize(weightUnit[reel.units.reel_weight]?.displayName) : "T"}</p>
                        </td>
                        <td>
                          <p className="p-ton f-10">
                            {reel.item_type === "order" ? reel.order_dim?.length : reel.stock_dim?.length} x {" "} 
                            {reel.item_type === "order" ? reel.order_dim?.width : reel.stock_dim?.width} {" "} {reel?.units && reel?.units?.width ? lengthUnit[reel.units.width]?.displayName?.toUpperCase() : "CM"}
                          </p>
                          <p className="reel f-10">{reel.item_type === "order" ? reel.order_dim?.grain : reel.stock_dim?.grain}</p>
                        </td>
                        {reel.item_type === "order" ? (
                          <td>
                            <p className="p-ton f-10">Customer: {reel.customer.name}</p>
                            {reel.delivery_date && <p className="reel f-10">
                              Delivery Date:{" "}
                              {moment(reel.delivery_date).format("DD-MM-YYYY")}
                            </p>}
                            {!reel.delivery_date && reel.category!='so' && <p className="reel f-10">
                              Delivery Date:</p>}
                          </td>
                        ) : (
                          <td >
                            <p className="p-ton f-10">-</p>
                          </td>
                        )}
                        {reel.item_type === "order" ? (
                          <td >
                          {reel.forced && <p className="p-ton f-10">YES</p>}
                          {!reel.forced && <p className="p-ton f-10">NO</p>}
                          </td>
                        ) : (
                          <td >
                            <p className="p-ton f-10">-</p>
                          </td>
                        )}
                        <td>
                          <p className="remark f-10">{reel.remarks}</p>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </ExportTable>
            </div>
          </Layout>
        </OtherPages>
      </PrintData>
    </RightLayoutContainer>
  ) : null;
};
export default PrintParentReelPdf;
